import config from "./config.json";

export const getApiBaseUrl = () => {
    if (document.location.hostname === "localhost") {
        return "http://localhost:3000";
    } else {
        return config.apiBaseUrl;
    }
};

export const getCognitoAuthConfig = () => {
    if (document.location.hostname === "localhost") {
        return {
            authority:
                "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_jXARVRSLV",
            client_id: "6tdk64u4oqtghfbj49q5ie1i8o",
            redirect_uri: "http://localhost:8020/",
            response_type: "code",
            scope: "phone openid email"
        };
    } else {
        return config.cognitoConfig;
    }
};
